export default "__VITE_ASSET__DLiY3ixp__"